// extracted by mini-css-extract-plugin
export default {"cls1":"mentions_milestone_ping-cls1_mVF","cls2":"mentions_milestone_ping-cls2__FL mentions_milestone_ping-cls1_mVF"};